/**
 * Downloads a file via the server-side proxy to avoid CORS issues.
 * Works reliably for all cross-origin URLs from our CDN/storage.
 */
export function downloadFile(url: string, filename: string) {
  const proxyUrl = `/api/download-image?url=${encodeURIComponent(url)}&filename=${encodeURIComponent(filename)}`;
  const a = document.createElement('a');
  a.href = proxyUrl;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
